import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class OtherWords extends Component {
	render() {
		return(
				<Panel><Panel.Heading>本单元其它单词和短语</Panel.Heading>
				<Panel.Body>
				<BootstrapTable
					data = { this.props.data }
					striped
					hover
					options = {{ noDataText: '没有可以显示的数据' }}
				>
					<TableHeaderColumn isKey hidden dataField='id'>
						ID
					</TableHeaderColumn>
					<TableHeaderColumn dataField='chinese'>
						中文
					</TableHeaderColumn>
					<TableHeaderColumn dataField='english'>
						英文
					</TableHeaderColumn>
				</BootstrapTable>
				</Panel.Body>
				</Panel>
		      )	
	}
}

export default OtherWords;



// WEBPACK FOOTER //
// ./src/Test_OtherWords.js